export default function Refrigerator() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_8627_11660)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.7116 22.9121H5.58132C5.24241 22.9121 4.93555 22.7803 4.71224 22.5663C4.48787 22.3513 4.34863 22.0526 4.34863 21.7225V1.82298C4.34863 1.5035 4.47894 1.21294 4.69122 0.999446C4.91558 0.773787 5.23137 0.632812 5.58132 0.632812H17.7116C18.0836 0.632812 18.4173 0.792042 18.6432 1.04407C18.8308 1.253 18.9443 1.5248 18.9443 1.82298V21.7225C18.9443 22.0744 18.7856 22.3908 18.5345 22.6084C18.3159 22.797 18.0279 22.9121 17.7116 22.9121Z"
                    stroke="#7293F7"
                    strokeWidth="0.9"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7.02441 4.70898V6.16114" stroke="#7293F7" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.02441 11.7402V14.3217" stroke="#7293F7" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4.34863 9.05078H18.9443" stroke="#7293F7" strokeWidth="0.9" />
            </g>
            <defs>
                <clipPath id="clip0_8627_11660">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
